<template>
  <div>
    <Header headerStyle='sub' :fixed-header='true' />
    <section class='sub terms'>
      <div class='sub__header'>
        <h1 class="title title--h1 title--center">
          전자금융거래 이용약관
        </h1>
        <div class="breadcrumb">
          <span class="breadcrumb__depth">
            홈 >
          </span>
          <span class="breadcrumb__current">
            전자금융거래 이용약관
          </span>
        </div>
      </div>
      <div class='sub__contents'>
        <h2 class='notice-top-title'>전자금융거래 서비스 이용약관</h2>
        <div class='list-container'>
          <h3>[목차]</h3>
          <ul class="column-list">
            <li>제1장 총칙</li>
            <li>제1조 목적</li>
            <li>제2조 용어의 정의</li>
            <li>제3조 전자금융거래서비스의 구성 및 내용</li>
            <li>제4조 이용 시간</li>
            <li>제5조 수수료</li>
            <li>제6조 전자지급거래계약의 효력</li>
            <li>제7조 접근매체의 발급</li>
            <li>제8조 접근매체의 선정과 사용 및 관리</li>
            <li>제9조 거래내용의 확인</li>
            <li>제10조 오류의 정정 등</li>
            <li>제11조 회사의 책임</li>
            <li>제12조 거래의 제한</li>
            <li>제13조 거래지시의 철회</li>
            <li>제14조 전자금융거래기록의 보존</li>
            <li>제15조 전자금융거래정보의 제공금지</li>
            <li>제16조 분쟁처리 및 분쟁조정</li>
            <li>제17조 회사의 안전성 확보 의무</li>
            <li>제18조 추심이체의 동의 및 철회</li>
            <li>제19조 약관의 명시·교부·설명</li>
            <li>제20조 약관의 변경</li>
            <li>제21조 약관 외 준칙</li>
            <li>제22조 관할</li>
            <li>제2장 선불전자지급수단의 발행 및 관리</li>
            <li>제23조 정의</li>
            <li>제24조 선불전자지급수단의 충전</li>
            <li>제25조 선불전자지급수단 이용 및 차감</li>
            <li>제26조 거래지시의 철회</li>
            <li>제27조 소멸시효</li>
            <li>제28조 유효기간</li>
            <li>제29조 환급기준</li>
            <li>제30조 선불전자지급수단의 한도 등</li>
            <li>제31조 착오송금에 관한 사항</li>
            <li>제32조 선불충전금의 보호 및 지급</li>
            <li>제33조 선불충전금 보호조치의 고지 및 게시</li>
            <li>부칙</li>
          </ul>

          <h4>제1장 총칙</h4>

          <h4>제 1조 (목적)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이 약관은 스푼 주식회사(이하 '회사'라 합니다)가 제공하는 전자금융거래에 대한 기본적인 사항을 정함으로써 전자금융거래를 이용하고자 하는 이용자와 회사 사이의 권리 및 의무 관계를 명확하게 정함을 목적으로 합니다.</li>
          </ul>

          <h4>제 2조 (용어의 정의)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 본 약관에서 정하는 용어의 정의는 다음과 같으며, 본 조 및 본 약관에서 별도로 정의하지 아니한 용어의 정의는 「전자금융거래법」 등 관련법령이 정한 바에 의합니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① "전자금융거래"라 함은 회사가 전자적 장치를 통하여 전자금융거래서비스를 제공하고, 이용자가 회사의 종사자와 직접 대면하거나 의사소통을 하지 아니하고 자동화된 방식으로 이를 이용하는 거래를 말합니다.</li>
                <li class="list-ul-bottom-li">② "전자지급거래"라 함은 자금을 주는 자(이하 '지급인'이라고 합니다)가 회사로 하여금 전자지급수단을 이용하여 자금을 받는 자(이하 '수취인'이라고 합니다)에게 자금을 이동하게 하는 전자금융거래를 말합니다.</li>
                <li class="list-ul-bottom-li">③ "전자지급수단"이라 함은 직불전자지급수단, 선불전자지급수단, 전자화폐, 신용 카드 등 「전자금융거래법」 제2조 제11호에서 정하는 전자적 방법에 따른 지급 수단을 말합니다.</li>
                <li class="list-ul-bottom-li">④ "전자적 장치"라 함은 전자금융거래정보를 전자적 방법으로 전송하거나 처리하는데 이용되는 장치로서 현금자동지급기, 자동입출금기, 지급용단말기, 컴퓨터, 전화기 그 밖에 전자적 방법으로 정보를 전송하거나 처리하는 장치를 말합니다.</li>
                <li class="list-ul-bottom-li">⑤ "전자문서"라 함은 「전자문서 및 전자거래 기본법」 제2조제1호에 따른 정보 처리시스템에 의하여 전자적 형태로 작성, 송신ㆍ수신 또는 저장된 정보를 말합니다.</li>
                <li class="list-ul-bottom-li">⑥ "이용자"라 함은 이 약관에 동의하고 회사가 제공하는 전자금융거래서비스를 이용하는 자를 말합니다.</li>
                <li class="list-ul-bottom-li">⑦ "비밀번호"라 함은 이용자의 동일성 식별과 이용자 정보의 보호를 위하여, 이용자가 설정하고 회사가 승인한 숫자와 문자의 조합을 말합니다.</li>
                <li class="list-ul-bottom-li">⑧ "접근매체"라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래 내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적 정보(신용카드번호를 포함한다), 「전자서명법」상의 전자서명생성정보 및 인증서, 회사에 등록된 이용자번호, 이용자의 생체정보, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등 전자금융거래법 제2조 제10호에서 정하고 있는 것을 말합니다.</li>
                <li class="list-ul-bottom-li">⑨ "거래지시"라 함은 이용자가 본 약관에 의하여 체결되는 전자금융거래계약에 따라 회사에 대하여 전자금융거래의 처리를 지시하는 것을 말합니다.</li>
                <li class="list-ul-bottom-li">⑩ "오류"라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말합니다.</li>
                <li class="list-ul-bottom-li">⑪ "가맹점"이라 함은 다음 각 목의 자를 말합니다.
                  <ul>
                    <li>가. 회사와의 계약에 따라 전자지급수단에 의한 거래에 있어서 이용자에게 재화 또는 용역을 제공하는 자</li>
                    <li>나. 회사와의 계약에 따라 이용자에게 재화 또는 용역을 제공하는 자를 위하여 전자지급수단에 의한 거래를 대행하는 자로서 「전자금융거래법 시행령」으로 정하는 자</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 본 조 및 본 약관에서 별도로 정의하지 아니한 용어의 정의는 「전자금융거래법」 등 관련법령이 정한 바에 의합니다.</li>
          </ul>

          <h4>제 3조 (전자금융거래서비스의 구성 및 내용)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 전자금융거래서비스는 다음 각 호의 서비스로 구성되며, 필요한 경우에는 이 약관 또는 개별약관에서 해당 서비스에 대한 자세한 내용을 기재합니다.
              <ol type="1">
                <li>선불전자지급수단의 발행 및 관리 서비스</li>
              </ol>
            </li>
            <li class="list-ul-top-li">② 회사는 전자금융거래서비스를 추가하거나 변경하고자 하는 경우에는 이용자에게 그 내용 및 적용일자 등을 사전 고지하고 해당 전자금융거래서비스를 추가하거나 변경할 수 있습니다.</li>
          </ul>

          <h4>제 4조 (이용 시간)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자에게 연중무휴 1일 24시간 전자금융거래 서비스를 제공함을 원칙으로 합니다. 단, 금융회사 기타 결제수단 발행업자의 사정에 따라 달라질 수 있습니다.</li>
            <li class="list-ul-top-li">② 회사가 이용시간을 변경하고자 하는 경우에는 그 내용을 이용자가 접근하기 용이한 전자적 장치를 통하여 변경 1개월 전부터 1개월간 알립니다. 다만, 시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 예외로 하며, 통지가 가능한 즉시 이용자에게 이러한 사정을 안내합니다.</li>
          </ul>

          <h4>제 5조 (수수료)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 전자금융 수수료를 이용자의 계좌에서 출금하거나 이용자로부터 직접 현금으로 받을 수 있으며, 수납방법은 개별약관에 따릅니다.</li>
            <li class="list-ul-top-li">② 회사는 수수료(율)를 이용자가 확인할 수 있도록 이용자가 접근하기 용이한 전자적 장치를 통하여 게시하고, 수수료(율)를 변경하는 경우에는 제20조(약관의 변경)을 준용합니다.</li>
          </ul>

          <h4>제 6조 (전자지급거래계약의 효력)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자의 거래지시가 전자지급거래에 관한 경우 그 지급절차를 대행하며, 전자지급거래에 관한 거래지시의 내용을 전송하여 지급이 이루어지도록 합니다.</li>
            <li class="list-ul-top-li">② 회사는 이용자의 전자지급거래에 관한 거래지시에 따라 지급거래가 이루어지지 않은 경우 수령한 자금을 이용자에게 반환하여야 합니다.</li>
          </ul>

          <h4>제 7조 (접근매체의 발급)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사가 접근매체를 발급할 때에는 이용자의 신청이 있는 경우에 한하여 본인임을 확인한 후에 발급합니다.</li>
            <li class="list-ul-top-li">② 제1항의 규정에도 불구하고 회사는 접근매체의 갱신 또는 대체발급 등을 위하여 이용자의 동의를 얻은 경우로서 다음 각 호에 해당하는 경우에는 이용자의 신청이나 본인확인이 없는 때에도 접근매체를 발급할 수 있습니다.
              <ol type="1">
                <li>갱신 또는 대체발급 예정일전 6개월 이내에 사용된 적이 없는 접근매체에 대하여 이용자로부터 갱신 또는 대체발급에 대한 서면[전자서명(서명자의 실지명의를 확인할 수 있는 것을 말합니다)이 있는 전자문서를 포함] 동의를 얻은 경우.</li>
                <li>갱신 또는 대체발급 예정일전 6개월 이내에 사용된 적이 있는 접근매체의 경우에는 그 예정일부터 1개월 이전에 이용자에게 발급 예정 사실과 20일 이내에 이의제기를 할 수 있다는 사실을 알린 후 20일 이내에 이용자로부터 이의제기가 없는 경우.</li>
              </ol>
            </li>
          </ul>

          <h4>제 8조 (접근매체의 선정과 사용 및 관리)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 전자금융거래서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인합니다.</li>
            <li class="list-ul-top-li">② 이용자는 접근매체를 사용함에 있어서 다른 법률에 특별한 규정이 없는 한 다음 각 호의 행위를 하여서는 아니됩니다.
              <ol type="1">
                <li>접근매체를 양도하거나 양수하는 행위</li>
                <li>접근매체를 제3자에게 대여하거나 사용을 위임하는 행위</li>
                <li>접근매체를 질권 기타 담보 목적으로 제공하는 행위</li>
                <li>1호부터 3호까지의 행위를 알선하는 행위</li>
              </ol>
            </li>
            <li class="list-ul-top-li">③ 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.</li>
            <li class="list-ul-top-li">④ 회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.</li>
          </ul>

          <h4>제 9조 (거래내용의 확인)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 개별 서비스 내 거래내역 조회 메뉴를 이용자가 자신의 거래내용(이용자의 오류정정 요구사실 및 처리결과에 관한 사항을 포함합니다)을 확인할 수 있도록 하며, 이용자가 거래내용에 대하여 서면 교부를 요청하는 경우에는 요청을 받은 날로부터 2주 이내에 모사전송, 우편 또는 직접 교부의 방법으로 거래내용에 관한 서면을 교부합니다.</li>
            <li class="list-ul-top-li">② 전자적 장치의 운영 장애, 그 밖의 사유로 거래내용을 제공할 수 없는 때에는 즉시 이용자에게 전자문서 전송(전자우편을 이용한 전송을 포함합니다)의 방법으로 그러한 사유를 알려야 하며, 전자적 장치의 운영장애 등의 사유로 거래내용을 제공할 수 없는 기간은 서면교부 기간에 산입하지 아니합니다.</li>
            <li class="list-ul-top-li">③ 제1항의 대상이 되는 거래 내용 중 대상기간이 5년인 것은 다음 각 호와 같습니다.
              <ol type="1">
                <li>거래계좌의 명칭 또는 번호</li>
                <li>전자금융거래의 종류 및 금액</li>
                <li>전자금융거래 상대방을 나타내는 정보</li>
                <li>전자금융거래일시</li>
                <li>전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보</li>
                <li>회사가 전자금융거래의 대가로 받은 수수료</li>
                <li>이용자의 출금 동의에 관한 사항</li>
                <li>해당 전자금융거래와 관련한 전자적 장치의 접속기록</li>
                <li>전자금융거래의 신청 및 조건의 변경에 관한 사항</li>
                <li>건당 거래금액이 1만원을 초과하는 전자금융거래에 관한 기록</li>
              </ol>
            </li>
            <li class="list-ul-top-li">④ 제1항의 대상이 되는 거래내용 중 대상기간이 1년인 것은 다음 각 호와 같습니다.
              <ol type="1">
                <li>건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록</li>
                <li>전자지급수단 이용과 관련된 거래승인에 관한 기록</li>
                <li>이용자의 오류정정 요구사실 및 처리결과에 관한 사항</li>
              </ol>
            </li>
            <li class="list-ul-top-li">⑤ 이용자가 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.
              <ul>
                <li>* 주소 : 서울특별시 강남구 논현로 706, 3, 7층 (논현동, 아이캐슬빌딩)</li>
                <li>* 이메일 주소 : donggookeom@lotte.net</li>
                <li>* 전화번호 : 02-3671-6491</li>
              </ul>
            </li>
          </ul>

          <h4>제 10조 (오류의 정정 등)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 전자금융거래 서비스를 이용함에 있어 오류가 있음을 안 때에는 회사에 대하여 그 정정을 요구할 수 있습니다.</li>
            <li class="list-ul-top-li">② 회사는 전항의 규정에 따른 오류의 정정요구를 받은 때 또는 스스로 오류가 있음을 안 때에는 이를 즉시 조사하여 처리한 후 정정요구를 받은 날 또는 오류가 있음을 안 날부터 2주 이내에 오류의 원인과 처리결과를 문서, 전화 또는 전자우편으로 이용자에게 알립니다. 다만, 이용자가 문서로 알려줄 것을 요청한 경우에는 문서로 알립니다.</li>
          </ul>

          <h4>제 11조 (회사의 책임)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 다음 각 호의 어느 하나에 해당하는 사고로 인하여 이용자에게 손해가 발생한 경우에는 그 손해를 배상할 책임을 집니다.
              <ol type="1">
                <li>접근매체의 위조나 변조로 발생한 사고</li>
                <li>계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고</li>
                <li>전자금융거래를 위한 전자적 장치 또는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제2조 제1항 제1호에 따른 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 발생한 사고</li>
              </ol>
            </li>
            <li class="list-ul-top-li">② 제1항 및 제8조 제4항에 의하여 금전적 손해가 발생한 경우 해당 금액 및 이에 대한 사전에 정한 이율로 계산한 경과이자를 배상합니다. 다만, 손해액이 해당 금액과 사전에 정한 이율로 계산한 금액을 초과하는 경우에는 실손해액을 배상합니다.</li>
            <li class="list-ul-top-li">③ 제1항에도 불구하고 회사는 이용자의 고의 또는 중과실로 다음 각 호의 행위를 하였음을 증명하는 경우에는 이용자에게 손해가 생기더라도 책임의 전부 또는 일부를 지지 아니합니다.
              <ol type="1">
                <li>이용자가 접근매체를 제3자에게 대여하거나 그 사용을 위임한 경우 또는 양도나 담보의 목적으로 제공한 경우(「전자금융거래법」 제18조에 따라 선불전자지급수단이나 전자화폐를 양도하거나 담보로 제공한 경우는 제외합니다.)</li>
                <li>제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 쉽게 알 수 있었음에도 불구하고 접근매체를 누설하거나 노출 또는 방치한 경우</li>
                <li>회사가 「전자금융거래법」 제6조 제1항에 따른 확인 외에 보안강화를 위하여 전자금융거래 시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 제1항 제3호에 따른 사고가 발생한 경우</li>
                <li>이용자가 제3호에 따른 추가적인 보안조치에 사용되는 매체ㆍ수단 또는 정보에 대하여 다음 각 목의 어느 하나에 해당하는 행위를 하여 제1항 제3호에 따른 사고가 발생한 경우
                  <ul>
                    <li>가. 누설ㆍ노출 또는 방치한 행위</li>
                    <li>나. 제3자에게 대여하거나 그 사용을 위임한 행위 또는 양도나 담보의 목적으로 제공한 행위</li>
                  </ul>
                </li>
                <li>법인(「중소기업기본법」 제2조제2항에 따른 소기업을 제외합니다)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우</li>
              </ol>
            </li>
            <li class="list-ul-top-li">④ 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체의 사유 등이 발생한 경우에는 전자금융거래서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 인터넷사이트 등을 통하여 이용자에게 전자금융거래서비스 제공의 중단 일정 및 중단 사유를 사전에 공지합니다.</li>
          </ul>

          <h4>제 12조 (거래의 제한)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 다음 각 호의 1에 해당하는 경우에는 전자금융거래의 해당 지시에 따른 거래를 제한할 수 있습니다.
              <ol type="1">
                <li>이용자가 접근매체에 의한 본인확인 외에 회사가 제공하는 추가적인 보안조치를 이용하지 아니할 때</li>
                <li>압류, 가압류, 가처분 등 법적 지급제한, 「전자금융거래법」 및 관련 법령 위반 등으로 거래 제공이 부적합하다고 회사가 인정했을 때</li>
              </ol>
            </li>
            <li class="list-ul-top-li">② 다음 각 호의 1에 해당하는 경우에는 해당 전자적 장치를 통한 계좌이체의 전부를 제한할 수 있습니다.
              <ol type="1">
                <li>회사가 정한 인증서의 유효기간이 만료되었거나 취소되었을 때</li>
                <li>컴퓨터 또는 전화기로 전자금융거래를 이용하는 이용자가 12개월 이상 이용실적이 없을 때</li>
              </ol>
            </li>
            <li class="list-ul-top-li">③ 회사가 제1항 및 제2항에 의해 전자금융거래를 제한한 경우에는 이용자의 거래지시가 있을 때 해당 전자적 장치를 통하여 그 사유를 알려야 합니다.</li>
            <li class="list-ul-top-li">④ 제2항의 경우에 이용자는 회사가 정한 인증서 재발급·유효기간의 연장 또는 계속 사용의사 확인 등의 절차를 거쳐 전자금융거래를 이용할 수 있습니다.</li>
          </ul>
          <h4>제 13조 (거래지시의 철회)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 회사의 전자금융거래서비스를 이용하여 전자지급거래를 한 경우 지급의 효력이 발생하기 전까지 본 약관에서 정한 바에 따라 제9조 제5항에 기재된 연락처로 전자문서의 전송(전자우편을 이용한 전송을 포함합니다) 또는 서비스 페이지 내 철회에 의한 방법으로 거래지시를 철회할 수 있습니다. 단, 각 서비스별 거래지시 철회의 효력 발생시기는 제26조에서 정한 바에 따릅니다.</li>
            <li class="list-ul-top-li">② 이용자는 전자지급의 효력이 발생한 경우에는 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령상 청약의 철회 방법에 따라 결제대금을 반환받을 수 있습니다.</li>
          </ul>

          <h4>제 14조 (전자금융거래기록의 보존)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자가 이용한 전자금융거래의 내용을 추적, 검색하거나 그 내용에 오류가 발생한 경우에 이를 확인하거나 정정할 수 있는 기록을 생성하여 보존합니다.</li>
            <li class="list-ul-top-li">② 전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및 보존기간은 제9조 제3항 내지 제4항에서 정한 바에 따릅니다.</li>
          </ul>

          <h4>제 15조 (전자금융거래정보의 제공금지)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 전자금융거래서비스를 제공함에 있어서 취득한 이용자의 인적사항, 이용자의 계좌, 접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료를 법령에 의하거나 이용자의 동의를 얻지 아니하고 제3자에게 제공, 누설하거나 업무상 목적 외에 사용하지 아니합니다.</li>
            <li class="list-ul-top-li">② 회사는 이용자가 안전하게 전자금융거래서비스를 이용할 수 있도록 이용자의 개인정보보호를 위하여 개인정보취급방침을 운용합니다. 회사의 개인정보취급방침은 회사의 홈페이지 또는 서비스 페이지에 링크된 화면에서 확인할 수 있습니다.</li>
          </ul>

          <h4>제 16조 (분쟁처리 및 분쟁조정)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 회사 홈페이지에 게시된 분쟁처리 책임자 및 담당자 또는 아래 연락처를 통하여 전자금융거래와 관련한 의견 및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할 수 있습니다.
              <ul>
                <li>* 담당자 : 스푼주식회사 페이사업팀 팀장</li>
                <li>* 주소 : 서울특별시 강남구 논현로 706, 3, 7층 (논현동, 아이캐슬빌딩)</li>
                <li>* 이메일 주소 : donggookeom@lotte.net</li>
                <li>* 전화번호 : 02-3671-6491</li>
              </ul>
            </li>
            <li class="list-ul-top-li">② 이용자는 제1항에 따라 서면(전자문서를 포함합니다) 또는 전자적 장치를 이용하여 회사의 본점이나 영업점에 분쟁처리를 신청할 수 있으며, 회사는 15일 이내에 이에 대한 조사 또는 처리결과를 이용자에게 안내합니다.</li>
            <li class="list-ul-top-li">③ 이용자는 회사의 전자금융거래의 처리에 관하여 이의가 있을 때에는 금융감독원의 금융분쟁조정위원회, 한국소비자원의 소비자분쟁조정위원회 등을 통하여 분쟁조정을 신청할 수 있습니다.</li>
          </ul>

          <h4>제 17조 (회사의 안전성 확보 의무)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">회사는 전자금융거래가 안전하게 처리될 수 있도록 선량한 관리자로서 주의를 다하며, 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.</li>
          </ul>

          <h4>제 18조 (추심이체의 동의 및 철회)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자가 추심이체의 동의를 함에 있어서는 회사가 제공하는 방식과 요건에 따른 전자서면으로 동의를 제공하여야 합니다.</li>
            <li class="list-ul-top-li">② 회사는 전자금융감독규정에서 정한 요건에 부합하는 방식과 요건의 전자서면을 통한 동의 방식을 제공하며, 추심이체의 실행을 위하여 이용자로부터 수령한 동의 사항을 금융결제원 및 해당 금융회사 등에게 제출합니다.</li>
            <li class="list-ul-top-li">③ 이용자는 회사의 거래지시에 따라 이용자의 계좌 원장에 출금기록이 기입되기 전까지 회사에 대하여 제1항의 규정에 따른 동의의 철회를 요청할 수 있습니다. 이용자는 서비스 화면을 통하여 회사에 등록된 계좌의 등록의 말소를 하는 방법으로 출금이체 동의를 철회할 수 있습니다. 다만, 이용자는 동 철회의 의사표시 이전에 발생한 출금 건에 대하여 이의를 제기할 수 없습니다.</li>
          </ul>

          <h4>제 19조 (약관의 명시·교부·설명)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자에게 약관을 명시하여야 하고, 이용자의 요청이 있는 경우 전자문서의 전송(전자우편을 이용한 전송을 포함합니다.), 모사전송, 우편 또는 직접 교부의 방식으로 약관의 사본을 이용자에게 교부하여야 합니다.</li>
            <li class="list-ul-top-li">② 회사는 이용자가 약관의 내용에 대한 설명을 요청하는 경우 다음 각 호의 어느 하나의 방법으로 이용자에게 약관의 중요내용을 설명하여야 합니다.
              <ol type="1">
                <li>약관의 중요내용을 이용자에게 직접 설명</li>
                <li>약관의 중요내용에 대한 설명을 전자적 장치를 통하여 이용자가 알기 쉽게 표시하고 이용자로부터 해당 내용을 충분히 인지하였다는 의사표시를 전자적 장치를 통하여 수령</li>
              </ol>
            </li>
          </ul>

          <h4>제 20조 (약관의 변경)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사가 이 약관을 변경하는 때에는 변경되는 약관의 시행일 1개월 전에 그 내용을 해당 전자금융거래를 수행하는 전자적 장치(해당 전자적 장치에 게시하기 어려울 경우에는 이용자가 접근하기 용이한 전자적 장치)에 게시하고 이용자에게 통지하여야 합니다. 다만, 이용자가 이의를 제기할 경우 회사는 이용자에게 적절한 방법으로 약관 변경내용을 통지하였음을 확인해 주어야 합니다.</li>
            <li class="list-ul-top-li">② 제1항에도 불구하고 법령의 개정으로 인하여 긴급하게 약관을 변경한 때에는 변경된 약관을 전자적 장치에 최소 1개월 이상 게시하고 이용자에게 통지하여야 합니다.</li>
            <li class="list-ul-top-li">③ 회사가 제1항 및 제2항에 따라 변경된 약관을 게시하거나 통지하는 경우에는 "이용자가 약관의 변경내용이 게시되거나 통지된 후부터 변경되는 약관의 시행일 전의 영업일까지 이내에 계약을 해지할 수 있으며, 약관의 변경내용에 이의를 제기하지 아니하는 경우 약관의 변경내용에 승인한 것으로 본다."라는 취지의 내용을 통지하여야 합니다.</li>
            <li class="list-ul-top-li">④ 이용자는 약관의 변경내용이 게시되거나 통지된 후부터 변경되는 약관의 시행일 전의 영업일까지 전자금융거래의 계약을 해지할 수 있고, 약관의 변경내용에 대하여 이의를 제기하지 아니하는 경우에는 약관의 변경을 승인한 것으로 봅니다.</li>
          </ul>

          <h4>제 21조 (약관 외 준칙)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사와 이용자 사이에 개별적으로 합의한 사항이 이 약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에 우선하여 적용합니다.</li>
            <li class="list-ul-top-li">② 전자금융거래에 관하여 이 약관에 정하지 않은 사항은 개별약관이 정하는 바에 따릅니다.</li>
            <li class="list-ul-top-li">③ 이 약관과 전자금융거래에 관한 개별약관에 정하지 않은 사항(용어의 정의 포함)에 대하여는 다른 합의사항이 없으면 「전자금융거래법」, 「전자상거래 등에서의 소비자 보호에 관한 법률」, 「여신전문금융업법」 등 관계 법령에서 정한 바에 따릅니다.</li>
          </ul>

          <h4>제 22조 (관할)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">회사와 이용자 간에 발생한 분쟁에 관한 관할은 「민사소송법」에서 정한 바에 따릅니다.</li>
          </ul>

          <h4>제2장 선불전자지급수단의 발행 및 관리</h4>

          <h4>제 23조 (정의)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">본 장에서 사용하는 용어의 정의는 다음과 같습니다.
              <ol type="1">
                <li>"선불전자지급수단"이라 함은 이전 가능한 금전적 가치가 전자적 방법으로 저장되어 발행된 증표(전자적 방법으로 변환되어 저장된 증표를 포함합니다) 또는 그 증표에 관한 정보로서 회사와 제휴한 가맹점에서 재화 또는 용역을 구입하고 그 대가를 지급하기 위해 사용할 수 있는 "모바일 상품권"(선불전자지급수단 명칭)을 의미합니다.</li>
                <li>"충전"이라 함은 선불전자지급수단의 일정액을 확보하기 위해 회사가 지정한 지불수단을 통해 선불전자지급수단을 구매하거나, 회사 또는 회사가 지정한 제3자의 서비스 등(이하 '서비스 등'이라 합니다)에서의 활동을 통해 선불전자지급수단을 적립 받는 것을 말합니다.</li>
                <li>"가맹점"이라 함은 다음 각 목의 자를 말합니다.
                  <ul>
                    <li>가. 회사와의 계약에 따라 선불전자지급수단에 의한 거래에 있어서 이용자에게 재화 또는 용역을 제공하는 자</li>
                    <li>나. 회사와의 계약에 따라 이용자에게 재화 또는 용역을 제공하는 자를 위하여 선불전자지급수단에 의한 거래를 대행하는 자로서 「전자금융거래법 시행령」으로 정하는 자</li>
                  </ul>
                </li>
              </ol>
            </li>
          </ul>

          <h4>제 24조 (선불전자지급수단의 충전)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 계좌출금, 휴대폰, 신용카드, 무통장입금, 기타 회사가 정하는 지불수단으로 선불전자지급수단을 구매하거나, 서비스 등에서의 활동으로 회사 또는 회사의 제휴사로부터 적립 받아 선불전자지급수단을 충전할 수 있습니다.</li>
            <li class="list-ul-top-li">② 회사가 지정한 지불수단을 통한 선불전자지급수단 구매는 제1항에서 규정하는 지불수단별로 지정된 금액으로 충전을 할 수 있으며, 지불수단에 따라 자체 제한금액이 있을 수 있습니다.</li>
          </ul>

          <h4>제 25조 (선불전자지급수단 이용 및 차감)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 회사가 정한 기한 및 이용방법에 따라 선불전자지급수단을 이용할 수 있으며, 회사는 그 구체적인 사항을 본 약관 또는 선불전자지급수단 관련 서비스 페이지를 통해 공지합니다.</li>
            <li class="list-ul-top-li">② 이용자는 서비스 등에서 재화 등을 구매할 때 선불전자지급수단을 지불수단으로 사용할 수 있습니다.</li>
            <li class="list-ul-top-li">③ 선불전자지급수단은 재화 등의 구매완료 시점에 즉시 차감됩니다.</li>
            <li class="list-ul-top-li">④ 이용자가 선불전자지급수단을 사용하는 경우 서비스 등에서 적립 받은 무상의 선불전자지급수단, 이용자가 구매한 선불전자지급수단의 순서로 차감합니다.</li>
            <li class="list-ul-top-li">⑤ 이용자가 선불전자지급수단을 사용한 재화 등의 구매를 취소하는 경우 회사는 재화 등 구매 시 사용한 선불전자지급수단을 재충전하는 것을 원칙으로 합니다.</li>
            <li class="list-ul-top-li">⑥ 회사는 이용자에게 불리하게 선불전자지급수단 이용 가맹점을 축소하거나 그 이용조건을 변경하는 경우에는 그 축소 또는 변경일로부터 7일 전까지 이용자에게 통지하여야 하며, 이 경우 제29조 제4항 제4호에 따라 이용자가 잔액 전부의 환급을 청구할 수 있다는 사실을 포함하여 통지하여야 합니다.</li>
          </ul>

          <h4>제 26조 (거래지시의 철회)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이용자가 선불전자지급수단을 이용하여 자금을 지급하는 경우, 이용자는 거래 지시된 금액의 정보가 수취인이 지정한 전자적 장치에 도달하기 전까지 거래지시를 철회할 수 있습니다.</li>
          </ul>

          <h4>제 27조 (소멸시효)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">회사가 발행한 선불전자지급수단의 소멸시효는 구매일 또는 최종 충전일로부터 5년(60개월)이며, 이용자는 회사가 정한 소멸시효 내에서만 회사가 발행한 선불전자지급수단을 사용할 수 있습니다. 다만, 회사가 자발적으로 선불전자지급수단의 사용을 허락한 경우에는 소멸시효를 적용하지 아니합니다.</li>
          </ul>

          <h4>제 27조 (소멸시효)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">회사가 발행한 선불전자지급수단의 소멸시효는 구매일 또는 최종 충전일로부터 5년(60개월)이며, 이용자는 회사가 정한 소멸시효 내에서만 회사가 발행한 선불전자지급수단을 사용할 수 있습니다. 다만, 회사가 자발적으로 선불전자지급수단의 사용을 허락한 경우에는 소멸시효를 적용하지 아니합니다.</li>
          </ul>

          <h4>제 28조 (유효기간)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 회사가 발행하는 선불전자지급수단의 유효기간을 1년 이상의 기간을 정하여 설정할 수 있으며, 선불전자지급수단의 유효기간을 별도로 정하지 아니한 경우 제27조에서 정한 소멸시효기간(5년)을 유효기간으로 봅니다.</li>
            <li class="list-ul-top-li">② 선불전자지급수단의 유효기간은 구매일 또는 최종 충전일로부터 1년입니다.</li>
            <li class="list-ul-top-li">③ 이용자는 회사에 유효기간 내에는 유효기간의 연장을 요청할 수 있고, 요청을 받은 회사는 특별한 사유가 없는 한 유효기간을 최소 3개월 단위로 연장합니다.</li>
            <li class="list-ul-top-li">④ 회사는 유효기간이 도래하기 30일 전 통지를 포함하여 3회 이상 이용자에게 유효기간의 도래, 유효기간의 연장 가능 여부와 방법, 유효기간 경과 후 소멸시효 완성 전 잔액의 90%를 반환받을 수 있다는 내용 등을 이메일 또는 문자메세지 등의 방법으로 통지하여야 합니다.</li>
            <li class="list-ul-top-li">⑤ 제1항 내지 제4항에도 불구하고 무상으로 적립·제공한 선불전자지급수단의 유효기간은 해당 관련한 서비스 등의 구매페이지 또는 이벤트 안내에 따라 결정되며, 회사는 무상 선불전자지급수단의 유효기간이 도래하기 전 이메일, 문자메시지 등을 통해 소멸예정인 무상 선불전자지급수단에 대해 안내합니다.</li>
          </ul>

          <h4>제 29조 (환급기준)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자는 선불전자지급수단의 구매일(충전일)로부터 7일 이내인 경우 구매(충전) 취소가 가능하며, 구매액(충전액) 전부를 환급받을 수 있습니다.</li>
            <li class="list-ul-top-li">② 이용자는 보유 중인 선불전자지급수단의 환급을 회사에 요구할 수 있으며, 회사는 환불수수료를 공제한 잔액 전부를 환급합니다.</li>
            <li class="list-ul-top-li">③ 선불전자지급수단의 환급 관련 환불수수료 부과 여부 및 부과기준 관련 구체적인 내용은 홈페이지나 앱을 통해 사전에 공지합니다. 다만, 신규로 수수료를 부과하거나 기존 수수료를 변경하게 되는 경우 시행 1개월 전에 홈페이지나 앱을 통해 공지하고 이용자에게 개별 통지합니다.</li>
            <li class="list-ul-top-li">④ 제2항 및 제3항에도 불구하고 다음 각 호의 어느 하나에 해당하는 경우에는 환불수수료 공제 없이 선불전자지급수단에 기록된 잔액 전부를 환급합니다.
              <ol type="1">
                <li>천재지변 등의 사유로 가맹점에서 재화 또는 용역을 제공하기 곤란하여 선불전자지급수단을 사용하지 못하게 된 경우</li>
                <li>선불전자지급수단의 결함으로 가맹점에서 재화 또는 용역을 제공하지 못하는 경우</li>
                <li>선불전자지급수단의 구매금액(충전형의 경우, 최종 충전시 그 시점의 잔액 기준)의 100분의 60(1만원 이하는 100분의 80) 이상을 사용한 경우</li>
                <li>이용자에게 불리하게 선불전자지급수단 이용 가맹점을 축소하거나 그 이용 조건을 변경하는 경우. 단, 가맹점 폐업, 가맹계약기간의 만료, 그 밖에 다음 각 목의 경우에는 그러하지 아니합니다.
                  <ul>
                    <li>가. 「전자금융거래법」 제38조제4항에 따라 가맹점계약을 해지하는 경우</li>
                    <li>나. 가맹점이 「전자금융거래법」, 「전자상거래 등에서의 소비자보호 등에 관한 법률」, 그 밖에 이용자 보호 및 건전한 거래질서 유지와 관련되는 법령으로서 전자금융감독규정에서 정하는 법령을 위반한 경우에는 가맹점계약을 해지한다는 내용이 포함된 약관에 따라 가맹점계약을 해지하는 경우</li>
                    <li>다. 선불전자지급수단을 이용할 수 있는 가맹점을 축소하더라도 선불전자지급수단을 이용할 수 있는 다른 가맹점이 충분하여 가맹점이 제공하는 재화·용역을 구입하려는 이용자의 이익을 저해할 우려가 없는 경우</li>
                    <li>라. 가목부터 다목까지에 준하는 경우로서 전자금융감독규정에서 정하는 정당한 이유가 있는 경우</li>
                  </ul>
                </li>
              </ol>
            </li>
            <li class="list-ul-top-li">⑤ 유효기간 경과 후(소멸시효가 완성되지 않은 경우에 한함), 이용자는 회사에게 선불전자지급수단에 기록된 미사용잔액에 대한 환급을 청구할 수 있으며, 회사는 잔액(유효기간 경과 전 청구하였더라면 지급받을 수 있었던 금액)의 90%를 환급합니다.</li>
            <li class="list-ul-top-li">⑥ 제1항 내지 제5항에도 불구하고 회사로부터 무상적립·제공받은 선불전자지급수단의 경우 환급대상에서 제외됩니다.</li>
            <li class="list-ul-top-li">⑦ 제4항 제4호에 따른 환급의 경우, 회사는 선불전자지급수단의 환급에 관한 내용을 회사의 인터넷 홈페이지에 가맹점 축소 또는 이용 조건이 변경되는 날로부터 30일 이상 게시합니다.</li>
          </ul>

          <h4>제 30조 (선불전자지급수단의 한도 등)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 선불전자지급수단에 대해 실지명의 당 최고 200만원을 그 보유 한도로 하고, 실지명의가 확인되지 않은 경우 50만원을 보유한도로 합니다. 단, 보유 한도는 회사의 정책에 따라 감액될 수 있으며, 회사는 이를 사전 안내합니다.</li>
            <li class="list-ul-top-li">② 회사의 정책 및 결제업체(이동통신사, 카드사 등)의 기준에 따라 이용자의 결제수단별 월 누적 결제액 및 결제한도가 제한될 수 있으며, 회사는 그 기준을 회사의 홈페이지 등을 통해 이용자에게 안내합니다.</li>
          </ul>

          <h4>제 31조 (착오송금에 관한 사항)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 이용자가 착오로 수취금융회사, 수취계좌번호 등을 잘못 기재하거나 입력하여 수취인에게 선불전자지급수단 등의 자금이 이동(이하 '착오송금'이라 합니다)된 경우, 회사에 통지하여 회사 또는 수취 금융회사 등을 통해 수취인에게 연락하여 착오송금액 반환을 요청할 수 있습니다.</li>
            <li class="list-ul-top-li">② 회사는 수취인에 대한 연락 사실, 수취인의 반환의사 유무, 수취인이 반환의사가 없는 경우 그 사유 등 이용자 요청사항에 대한 처리결과 또는 관련 처리 진행상황을 이용자가 전항의 착오송금 발생사실을 회사에 통지한 날로부터 15일 이내에 이용자에게 알려야 합니다.</li>
            <li class="list-ul-top-li">③ 회사 또는 수취 금융회사를 통한 착오송금 반환 요청에도 수취인이 반환하지 않는 경우, 이용자는 「예금자보호법」 제5장(착오송금 반환지원)에 따라 예금보험공사에 착오송금 반환지원 제도 이용을 신청할 수 있습니다.(개정 「예금자보호법」 시행일인 '21.7.6. 이후 발생한 착오송금에 대해 신청 가능) 단, 연락처를 통한 송금, SNS회원간 송금 거래 등 예금보험공사가 수취인의 실지명의를 취득할 수 없는 거래는 반환지원 신청이 제한됩니다.</li>
            <li class="list-ul-top-li">④ 회사는 예금보험공사가 착오송금 반환지원 업무의 원활한 수행을 위해 회사에 착오송금 수취인의 반환불가 사유, 실지명의, 주소 및 연락처, 착오송금 발생현황 등의 자료를 요청하는 경우 정당한 사유가 없으면 이에 따라야 합니다.</li>
            <li class="list-ul-top-li">⑤ 이용자가 예금보험공사를 통해 착오송금 반환지원을 신청한 내역이 다음 각 호에 해당하는 경우 관련 법령에 따라 예금보험공사 지원절차가 중단될 수 있습니다.
              <ol type="1">
                <li>이용자가 거짓이나 부정한 방법으로 반환지원을 신청한 경우</li>
                <li>착오송금이 아님이 객관적인 자료로 확인되는 경우</li>
                <li>신청일 이전 반환 지원을 신청한 착오송금 관련 소송 등이 진행 중이거나 완료된 경우</li>
                <li>그 밖에 예금보험위원회가 인정하는 경우</li>
              </ol>
            </li>
          </ul>

          <h4>제 32조 (선불충전금의 보호 및 지급)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자의 선불충전금 100분의 100 이상의 금액을 은행 등 선불충전금관리기관을 통하여 다음 각 호의 어느 하나에 해당하는 방법으로 별도관리하여야 합니다.
              <ol type="1">
                <li>신탁</li>
                <li>예치</li>
                <li>이용자를 피보험자로 하는 지급보증보험</li>
              </ol>
            </li>
            <li class="list-ul-top-li">② 회사가 제1항에 따라 별도관리하는 선불충전금은 이용자의 재산이며, 선불충전금에 관한 청구권을 가지는 이용자는 회사가 선불충전금으로 별도관리하는 재산에 대하여 다른 채권자보다 우선하여 변제 받을 권리가 있습니다.</li>
            <li class="list-ul-top-li">③ 회사는 다음 각 호의 어느 하나에 해당하는 경우 선불충전금관리기관에게 즉시 그 사실을 통지하고, 이용자의 청구에 따라 선불금충전관리기관을 통하여 이용자에게 선불충전금을 우선 지급하여야 합니다. 이 경우 회사는 선불충전금관리기관과 협의하여 다음 각 호의 사유가 발생한 날부터 1개월 이내에 선불충전금의 지급사유, 지급시기, 지급방법, 그 밖에 선불충전금의 지급과 관련된 사항을 둘 이상의 일간신문에 공고하고 회사의 인터넷 홈페이지(이동통신단말장치에서 사용되는 애플리케이션, 그 밖에 이와 비슷한 응용프로그램을 통하여 회사가 가상의 공간에 개설하는 장소를 포함합니다.)를 통하여 게시하여야 합니다.
              <ol type="1">
                <li>허가 또는 등록이 취소되거나 말소된 경우</li>
                <li>해산의 결의를 한 경우</li>
                <li>파산선고를 받은 경우</li>
                <li>선불전자지급수단 발행 및 관리 업무 전부의 정지명령을 받은 경우</li>
                <li>제1호부터 제4호까지에 준하는 사유가 발생한 경우</li>
              </ol>
            </li>
            <li class="list-ul-top-li">④ 이용자는 별도관리하는 선불충전금을 제3항에 따라 지급 청구하려는 경우, 다음 각 호의 사항을 기재한 서면을 선불충전금관리기관에 제출해야 합니다.
              <ol type="1">
                <li>이용자 또는 선불전자지급수단을 식별할 수 있는 정보</li>
                <li>선불충전금을 지급받을 계좌에 관한 정보</li>
              </ol>
            </li>
            <li class="list-ul-top-li">⑤ 제3항에 따라 이용자에게 선불충전금을 지급하여야 하는 경우, 회사는 해당 이용자에 관한 다음 각 호의 정보를 선불충전금관리기관에게 제공할 수 있습니다.
              <ol type="1">
                <li>이용자 식별 정보</li>
                <li>이용자에게 지급하여야 할 선불충전금에 관한 정보</li>
                <li>선불전자지급수단 식별 정보(「금융실명거래 및 비밀보장에 관한 법률」제2조 제4호에 따른 실지 명의가 확인되지 않는 등의 사유로 이용자를 식별할 수 없는 선불전자지급수단의 경우)</li>
                <li>그 밖에 선불충전금 지급에 필요한 정보</li>
              </ol>
            </li>
          </ul>

          <h4>제 33조 (선불충전금 보호조치의 고지 및 게시)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 이용자와 선불전자지급수단에 관한 계약 체결시 선불충전금 보호조치에 관한 다음 각 호의 사항을 이용자에게 고지합니다.
              <ol type="1">
                <li>선불충전금의 별도관리 방법</li>
                <li>선불충전금관리기관의 명칭 등 선불충전금관리기관에 관한 정보</li>
                <li>제32조 제3항에 따른 선불충전금 지급사유, 이용자의 청구 방법 등 선불충전금 지급절차에 관한 사항</li>
              </ol>
            </li>
            <li class="list-ul-top-li">② 회사는 제1항에 따른 선불충전금 보호조치의 내용을 인터넷 홈페이지에 항상 게시하여야 하고, 그 고지 내용의 세부사항 변경 시 즉시 게시된 고지 내용을 변경합니다.</li>
          </ul>

          <h4>부칙</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이 약관은 2025년 5월 2일부터 적용됩니다.</li>
          </ul>
        </div>
      </div>
      <TermsList />
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import Header from '@/components/Header';
import Spinner from '@/components/Spinner';
import TermsList from '@/components/TermsList';

require('es6-promise').polyfill();

export default {
  components: {
    Header,
    Spinner,
    TermsList
  },
  data() {
    return {
      loading: true,
      selectData: [],
      body: {}
    };
  },
  async created() {
    try {
      // 셀렉트박스 데이터 조회
      await axios
        .post(`${process.env.API_URL}/terms/day`, {
          ntro_se_code: '000001'
        })
        .then(res => {
          const {
            data: {
              return_cd,
              response: { data }
            }
          } = res;

          if (return_cd === '0000' && data.length > 0) {
            this.selectData = data;
          } else {
            this.body = {
              ntro_bdt: '조회된 데이터가 없습니다.'
            };
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.body = {
            ntro_bdt: '조회된 데이터가 없습니다.'
          };
          this.loading = false;
        });

      // 셀렉트박스 데이터 조회 기준 최근 날짜 조회
      await axios
        .post(`${process.env.API_URL}/terms`, {
          ntro_se_code: '000001',
          ntro_wrt_pit: this.selectData[0].ntro_wrt_pit
        })
        .then(res => {
          const {
            data: {
              return_cd,
              response: { data }
            }
          } = res;
          if (return_cd === '0000' && data !== null) {
            this.body = data;
          } else {
            this.body = {
              ntro_bdt: '조회된 데이터가 없습니다.'
            };
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.body = {
            ntro_bdt: '조회된 데이터가 없습니다.'
          };
          this.loading = false;
        });
    } catch (err) {
      console.log(err);
    }
  }
};
</script>

<style scoped lang='scss'>
@import "@/assets/styles/mixin.scss";
.terms {
  padding-top: 100px;
  width: 1140px;
  margin: 0 auto;
  letter-spacing: -0.05em;
}
.notice-top-wrap {
  width: 100%;
  margin-bottom: 10px;
  @include flexbox();
  @include justify-content(space-between);
  .notice-top-title {
    font-size: 18px;
    color: #222;
    vertical-align: center;
  }
  .select-wrap {
    width: 165px;
    vertical-align: center;
    select {
      font-size: 15px;
      color: #666;
      padding: 3px 52px 5px 10px;
      margin-left: -16px;
      height: 30px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: url(../assets/images/btn-select.png) no-repeat 95% 50%;
      &::-ms-expand{
        display: none;
      }
    }
  }
}
.list-container {
  border-top: 1px solid #e6e6e6;
  padding-top: 30px;
  .list-top-normal {
    font-size: 16px;
    color: #666;
    line-height: 34px;
    margin-bottom: 52px;
  }
  h3 {
    margin-bottom: 13px;
    font-size: 22px;
    color: #222;
    font-weight: bold;
  }
  h4 {
    margin-bottom: 13px;
    font-size: 18px;
    color: #222;
    font-weight: bold;
  }
  .list-ul-top {
    margin-bottom: 50px;
    li {
      font-size: 16px;
      color: #666;
      line-height: 34px;
      &.list-ul-top-p {
        margin-bottom: 23px;
      }
      &.list-ul-bottom-title {
        color: #222;
        .list-ul-bottom {
          margin: 4px 0 23px 19px;
          li {
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
.column-list{
  margin-bottom:50px;
  li{
    font-size:18px;
    margin-top:18px;
  }
}
.table{
  width:100%;
  margin-top:10px;
  thead{
    th{
      border:1px solid #ebeef5;
      background:#fafafa;
      text-align:center;
    }
  }
  tbody{
    td{
      padding:5px 10px;
      border:1px solid #ebeef5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TermsV2.vue